export const EDIT_PUBLISHED_PETITION_ERROR = 'edit_page_save_error';
export const AUTHENTICATION_EDIT_PUBLISHED_PETITION_ERROR = 'authentication_error';
